import styled from '@emotion/styled'

export const Cont = styled.div({
  display: 'flex',
  flexDirection: 'column',
})

export const TableData = styled.table({
  borderCollapse: 'collapse',
  width: '100%',
  borderTopLeftRadius:'1rem',
  borderTopRightRadius:'1rem',

  'td, th': {
    border: '1px solid #dddddd',
    textAlign: 'left',
    padding: '8px',
  },
})